import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { PortalService } from '../../../../../core/services/portal.service';
import { Intent } from '../models/intent.model';


@Injectable()
export class IntentService {
  private load$: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {
  }

  getIntents(botId: string, params?: any) {
    return this.http.get<{intents: Intent[], total: number, status: boolean}>(PortalService.ApiUrl + '/intents/' + botId, {params});
  }

  getMinds() {
    return this.http.get<any>(PortalService.ApiUrl + '/minds');
  }

  getTags(botId: string): Observable<any> {
    return this.http.get<any>(PortalService.ApiUrl+ '/tags/' + botId);
  }

  setNewTag(body: {bot_id: string, name: string}): Observable<any> {
    return this.http.post<any>(PortalService.ApiUrl+ '/tag/', body);
  }

  deleteTag(tag_id: string): Observable<any> {
    return this.http.delete<any>(PortalService.ApiUrl+ '/tag/' + tag_id);
  }

  changeTagColor(tagId: string, body: {bot_id: string, name: string, color: string}): Observable<any> {
    return this.http.put<any>(PortalService.ApiUrl+ '/tag/' + tagId, body);
  }

  getScenarious(botId: string): Observable<any> {
    return this.http.get<any>(PortalService.ApiUrl + '/scenarios/' + botId);
  }

  saveIntent(body: object) {
    return this.http.post<any>(PortalService.ApiUrl + '/intent', body);
  }

  updateIntent(intentID: string, body: object) {
    return this.http.put<any>(PortalService.ApiUrl + '/intent/' + intentID, body);
  }

  deleteIntent(intentID: string) {
    return this.http.delete<any>(PortalService.ApiUrl + '/intent/' + intentID);
  }

  downloadIntents(url: string): Observable<Blob> {
    return this.http.get(url, {responseType: 'blob'});
  }

  load() {
    return this.load$;
  }

  toLoad() {
    this.load$.next();
  }

}